module.exports = __webpack_public_path__ + "media/auto_history/kradziez-4ffb230f.svg";